<template>
  <div class="issuer">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <!-- <v-breadcrumbs :items="['Acquirer']"></v-breadcrumbs>  -->
          <v-breadcrumbs :items="['Card Range']"></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact">Add Acquirer</v-btn>  -->
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_MOD_CARD')              
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            New Range
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          label="Search"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchCardRange"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="cardRange"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.acquirer="{ item }">
          <td>
            <tr v-for="it in item.raw.acquirers" :key="it.id">
              <td>{{ it.acquirerName }}</td>
            </tr>
          </td>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="green"
                small
                class="mr-2"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_MOD_CARD')                  
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="red"
                small
                @click="compose_delete(item.raw.id)"
                v-if="this.global_permissions.includes('ROLE_DEL_CARD')||
              this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD I DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form ref="addIssuer" v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">New Range </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- <v-col cols="12">                                 
                        <v-text-field label="Name" :readonly="loading" :rules="[required]" clearable v-model="issuer_data.f_name" ></v-text-field>                                              
                      </v-col> -->
                  <v-col cols="12">
                    <v-autocomplete
                      :items="issuers"
                      item-title="name"
                      item-value="id"
                      label="Select Issuer"
                      :rules="[required]"
                      v-model="range_data.f_issuerId"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="PAN Range Low"
                      :readonly="loading"
                      :rules="[required, validatePan]"
                      clearable
                      v-model="range_data.f_lowRange"
                      maxlength="10"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="PAN Range High"
                      :readonly="loading"
                      :rules="[required, validatePan]"
                      clearable
                      v-model="range_data.f_highRange"
                      maxlength="10"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12">                                 
                        <v-text-field label="PAN Length" :readonly="loading" clearable v-model="range_data.f_panLength" ></v-text-field>                                             
                      </v-col> -->

                  <!-- <v-col cols="12">                                 
                        <v-autocomplete
                          :items="acquirers"
                          item-title="name"
                          item-value="id"
                          label="Select Acquirers"
                          multiple
                          :rules="[required]"
                          v-model="range_data.f_acquirerList"
                        ></v-autocomplete>                       
                      </v-col> -->
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addRange"
              >
                {{ $t("Save") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD DIALOG -->

    <!-- UPDATE DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Update Range</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      :items="issuers"
                      item-title="name"
                      item-value="id"
                      label="Select Issuer"
                      :rules="[required]"
                      v-model="range_data.f_issuerId"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="PAN Range Low"
                      :readonly="loading"
                      clearable
                      :rules="[required, validatePan]"
                      v-model="range_data.f_lowRange"
                      maxlength="10"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="PAN Range High"
                      :readonly="loading"
                      clearable
                      :rules="[required, validatePan]"
                      v-model="range_data.f_highRange"
                      maxlength="10"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12">                                 
                        <v-text-field label="PAN Length" :readonly="loading" clearable v-model="range_data.f_panLength" ></v-text-field>                                             
                      </v-col> -->

                  <!-- <v-col cols="12">                                 
                        <v-autocomplete
                          :items="acquirers"
                          item-title="name"
                          item-value="id"
                          label="Select Acquirers"
                          multiple
                          :rules="[required]"
                          v-model="range_data.f_acquirerList"
                        ></v-autocomplete>                       
                      </v-col>  -->
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="dialog_update = false"
              >
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateRange"
              >
                {{ $t("Update") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->

    <!-- DELETE DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <div class="container">
                  <span class="text-h5">{{ $t('Do you want to delete') }} ?</span></div>
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_delete = false"
                  >
                    {{ $t('Close') }}
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="deleteRange"
                  >
                    {{ $t('Delete') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">Delete File</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          Are you sure you want to delete this file?
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteRange">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END DELETE DISCOUNT DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "CardRange",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      acquirers: [],
      issuers: [],
      cardRange: [],
      organization: [],
      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      range_data: {
        //f_name: '',
        //f_issuerList: [],
        f_issuerId: "",
        f_lowRange: "",
        f_highRange: "",
        f_panLength: "",
        f_acquirerList: [],
        f_orgId: "",
      },

      cardRangeId: "",
      cardRange_response: [],
      search: "",
      headers: [
        /* {
            title: 'Id',            
            align: 'start',
            sortable: false,
            key: 'cardRangeId',
          }, */
        { title: "Name", align: "start", key: "issuer.name" },
        { title: "Low Range", key: "panRangeLow" },
        { title: "High Range", key: "panRangeHigh" },
        //{ title: 'Acquirers', key: 'acquirer', sortable: true },
        { title: "Organization", key: "organization.orgName", sortable: true },
        {
          title: this.$t("Actions"),
          key: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      //form
      form: false,
      loading: true,
      //email_exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  created() {},

  computed: {
    pageCount() {
      //console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);

      return count;
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },
  },

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetInput(){
      this.range_data.f_issuerId = "";
      this.range_data.f_lowRange = "";
      this.range_data.f_highRange = "";
      this.range_data.f_panLength = "";
      this.range_data.f_acquirerList = [];
      this.range_data.f_orgId = "";
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    required(v) {
      return !!v || "Field is required";
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.cardRangeId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.cardRangeId = id;
      this.dialog_delete = true;
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    requests_handler() {
      //second method
      axios
        .all([
          //axios.get(window.baseurl+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          /* axios.get(window.baseurl+"acquirer/org/"+this.orgId  , 
              {"headers": {'Authorization': 'Bearer ' + this.accessToken} }
            ), */
          axios.get(window.baseurl + "issuers/org/" + this.orgId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((issuer_response) => {
            // console.log("data2", issuer_response);

            //if response data is an array // handle it as below
            /* if(acquirer_response.status == 200){   
                  if(acquirer_response.data.records != null && acquirer_response.data.records.length > 0){
                      let i = 0;
                      this.acquirers = [];   //remove all items from array
                      for(i=0; i<acquirer_response.data.records.length; i++){                                              
                          this.acquirers.push({ id: acquirer_response.data.records[i].id, name: acquirer_response.data.records[i].acquirerName });                          
                          //console.log("acquirers", this.acquirers)                         
                      }                      
                  }
              } */

            if (issuer_response.status == 200) {
              if (
                issuer_response.data.records != null &&
                issuer_response.data.records.length > 0
              ) {
                let i = 0;
                this.issuers = []; //remove all items from array
                for (i = 0; i < issuer_response.data.records.length; i++) {
                  this.issuers.push({
                    id: issuer_response.data.records[i].id,
                    name: issuer_response.data.records[i].name,
                  });
                  // console.log("acquirers", this.issuers);
                }
              }
            }

            //if response data is a single object // handle it as below
            /* if(second_response.status == 200){  
                  this.organization = [];  //remove all items from array
                  this.organization.push(second_response.data);                          
                  console.log("organization1", this.organization)
                  
              } */
          })
        );
    }, //end of requests_handler method

    async addRange() {
      //this.dialog = false
      // console.log("form data", this.range_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "cardRanges",
          {
            //name:this.issuer_data.f_name,
            issuer_id: this.range_data.f_issuerId,
            panRangeLow: this.range_data.f_lowRange,
            panRangeHigh: this.range_data.f_highRange,
            panLength: 0,
            organization_id: this.orgId,
            //acquirersList:this.range_data.f_acquirerList,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("log in successfull");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: "New Card Range Added" });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "cardRanges/" + this.cardRangeId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          //axios.get(window.baseurl+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          //axios.get(window.baseurl+"acquirer/"+this.orgId +"/org" , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "issuers/org/" + this.orgId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((cardRange_response, issuer_response) => {
            // console.log("data1", issuer_response.data);
            // console.log("data3", cardRange_response.data);

            //get  data for selected id and display data in for dialog
            if (cardRange_response.status == 200) {
              // console.log("cardRange Data", this.cardRange_response);
              //this.range_data.f_name = cardRange_response.data.name
              this.range_data.f_issuerId =
                cardRange_response.data.issuer.id;
              this.range_data.f_lowRange = cardRange_response.data.panRangeLow;
              this.range_data.f_highRange =
                cardRange_response.data.panRangeHigh;
              this.range_data.f_panLength = cardRange_response.data.panLength;
            }

            if (issuer_response.status == 200) {
              if (
                issuer_response.data.records != null &&
                issuer_response.data.records.length > 0
              ) {
                let i = 0;
                this.issuers = []; //remove all items from array
                for (i = 0; i < issuer_response.data.records.length; i++) {
                  this.issuers.push({
                    id: issuer_response.data.records[i].id,
                    name: issuer_response.data.records[i].name,
                  });
                  //console.log("acquirers", this.issuers)
                }
              }
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateRange() {
      this.dialog_update = false;
      this.checkTokenExpiry();
      try {
        // console.log("update form cardRange id", this.cardRangeId);
        // console.log("update form cardRange data", this.range_data);
        let result = await axios.put(
          window.baseurl + "cardRanges/" + this.cardRangeId,
          {
            //name:this.issuer_data.f_name,
            issuer_id: this.range_data.f_issuerId,
            panRangeLow: this.range_data.f_lowRange,
            panRangeHigh: this.range_data.f_highRange,
            panLength: 0,
            organization_id: this.orgId,
            //acquirersList:this.range_data.f_acquirerList,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: "Card Range Updated" });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteRange() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "cardRanges/" + this.cardRangeId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );

        if (result.status == 204) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: "Card Range Deleted" });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "cardRanges", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("cardRange_object", result);
          this.cardRange = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_CARD")          
        ) {
          result = await axios.get(
            window.baseurl + "cardRanges/org/" + this.orgId,
            {
              params: { page: page2 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("cardRange_object", result);
          this.cardRange = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchCardRange() {
      let result;
      let page2 = this.page - 1; //pagination starts from 1 in vue , in spring boot pgae start from zero
      this.loading = true;
      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "cardRanges/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("search_cardRange_object", result);
          this.cardRange = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_CARD")          
        ) {
          result = await axios.get(
            window.baseurl + "cardRanges/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("search_cardRange_object", result);
          this.cardRange = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    /*VALIDATIOn RULES */

    validatePan(value) {
      const regex = /^[0-9]{10}$/ ;
      return (
        regex.test(value) ||
         "Field must be exactly 10 characters long and can only contain numbers."
      );
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get user list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
